import VueRouter from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import { magicConfig, modalService } from '@gig/magic-common';
import { RouteName } from '../../../routes/routes.constants';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';
import { IConsent } from '@gig/magic-sdk/dist/adapter/users/consents';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
/**
 * Guard to check if user has consented to details reverification
 * @param router
 */

export function initVerifyDetailsModalGuard(router: VueRouter) {
    const language = magicConfig.language;

    router.beforeEach(async (to, _, next) => {
        if (!magic.session.getUser() || to.name === RouteName.LOGOUT) {
            return next();
        }

        const isPepBlocked = await window.queryBus.query<boolean>(
            ACCOUNT_PEP_BLOCK_QUERY,
        );
        if (isPepBlocked) {
            return next();
        }

        const profileV2Promise: ReturnType<
            typeof magic.methods.users.getProfileV2
        > = magic.invokeCached(60, magic.methods.users, 'getProfileV2')();

        const user = await profileV2Promise;

        const consents = (await magic.invokeCached(
            60,
            magic.methods.users,
            'getUserConsents',
        )(language)) as IConsent[];

        const needsReverification = consents.some(
            (consent) =>
                consent.name == ConsentName.DETAILS_REVERIFICATION &&
                !consent.consented,
        );

        if (
            user &&
            user.country === Country.CANADA &&
            needsReverification &&
            !isVerifyDetailsModalOpen()
        ) {
            const modal = document.createElement('magic-verify-details-modal');
            const header = 'verify-details-modal.title';
            const modalOptions = {
                dismissible: false,
                displayOnTop: true,
                keepAfterClear: true,
            };
            modalService.open(header, modal, modalOptions);
            return next({ name: RouteName.HOME });
        }
        next();
    });

    function isVerifyDetailsModalOpen() {
        return (
            document.getElementsByTagName('magic-verify-details-modal')
                .length != 0
        );
    }
}
